module.exports = __webpack_public_path__ + "dash_20_app_assets/img/askonsocial.e6dceb7a.png";